<div
  (click)="appMain.rightMenuClick = true"
  [ngClass]="{ 'layout-sidebar-right-active': appMain.rightMenuActive }"
  class="layout-sidebar-right"
>
  <h5>Activity</h5>
  <div class="widget-timeline">
    <div class="timeline-event">
      <span class="timeline-event-icon" style="background-color: #64b5f6">
        <i class="pi pi-dollar"></i>
      </span>
      <div class="timeline-event-title">New Sale</div>
      <div class="timeline-event-detail">
        Richard Jones has purchased a product for <strong>R79</strong>.
      </div>
    </div>
    <div class="timeline-event">
      <span class="timeline-event-icon" style="background-color: #4db6ac">
        <i class="timeline-icon pi pi-question"></i>
      </span>
      <div class="timeline-event-title">Question Received</div>
      <div class="timeline-event-detail">
        Jane Davis has posted a <strong>new question</strong> about your
        product.
      </div>
    </div>
    <div class="timeline-event">
      <span class="timeline-event-icon" style="background-color: #4dd0e1">
        <i class="timeline-icon pi pi-comment"></i>
      </span>
      <div class="timeline-event-title">Comment Received</div>
      <div class="timeline-event-detail">
        Claire Smith has upvoted your store along with a
        <strong>comment</strong>.
      </div>
    </div>
  </div>

  <!--  <hr />-->

  <!--  <h5>Quick Withdraw</h5>-->

  <!--  <div class='withdraw '>-->
  <!--    <div>-->
  <!--      <input pInputText placeholder='Amount' type='text' />-->
  <!--    </div>-->
  <!--    <div>-->
  <!--      <p-dropdown [(ngModel)]='selectedAmount' [options]='amount'></p-dropdown>-->
  <!--    </div>-->
  <!--    <div>-->
  <!--      <button icon='pi pi-check' label='Confirm' pButton type='button'></button>-->
  <!--    </div>-->
  <!--  </div>-->

  <hr />

  <h5>Shipment Tracking</h5>
  <p>Track your ongoing shipments to customers.</p>
</div>
